import { Option, none, isNone, some } from 'fp-ts/lib/Option';

export default interface ReadPresetFormCriteria {
    preset: string;
}

class ReadPresetFormCriteriaImpl implements ReadPresetFormCriteria {
    constructor(readonly preset: string) {}
}

export class ReadPresetFormCriteriaBuilder {
    private preset: Option<string> = none;

    static create = (): ReadPresetFormCriteriaBuilder => new ReadPresetFormCriteriaBuilder();

    withPreset = (preset: string): ReadPresetFormCriteriaBuilder => {
        this.preset = some(preset);
        return this;
    };

    build = (): ReadPresetFormCriteria => {
        if (isNone(this.preset)) {
            throw new ReferenceError('Undefined prop');
        }

        return new ReadPresetFormCriteriaImpl(this.preset.value);
    };
}
